<template>
  <div style="height: calc(100vh - 88px); overflow: scroll" class="echarts">
    <p class="title">数据分析</p>
    <el-form class="df tit_search">
      <!-- {{ jcy }} -->
      <el-form-item label="检察院" class="df">
        <!-- <el-input v-model="jcy"></el-input> -->
        <!-- <el-select v-model="jcy" filterable placeholder="请选择" clearable>
          <el-option
            v-for="item in restaurants"
            :key="item.id"
            :label="item.value"
            :value="item.id"
          >
          </el-option>
        </el-select> -->
        <el-cascader
          :show-all-levels="false"
          v-model="selectedOptions"
          :options="optionsList"
          :props="optionProps"
          clearable
          @change="handleChange"
          ref="demoCascader"
        ></el-cascader>
      </el-form-item>
      <el-form-item label="获奖时间" class="df" style="margin-left: 15px">
        <!-- {{ time }} -->
        <el-date-picker
          v-model="time"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="timestamp"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item label="市" class="df" style="margin: 0 15px" >
        <!-- <el-input v-model="jcy"></el-input> -->
        <el-select v-model="city" filterable placeholder="请选择" clearable>
          <el-option
            v-for="item in shilist"
            :key="item.id"
            :label="item.name"
            :value="item.id"
            
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="" style="margin-top: -3px">
        <el-button type="primary" @click="LOOK_ECHART">搜索</el-button>
      </el-form-item>
    </el-form>
    <div class="list-look">
      <div class="quansheng">
        <p>全省总获奖人数</p>
        <p>
          <span>{{ dataList.length > 0 ? dataList[6][0].name : "0" }}</span
          >人
        </p>
      </div>
      <div class="quansheng-right">
        <div class="guo">
          <img src="@/assets/home/country.png" alt="" />
          <div>
            <span
              >{{ dataList.length > 0 ? dataList[0][0].total : "0"
              }}<b style="font-size: 14px">人</b></span
            >
            <p>国家级</p>
          </div>
        </div>
        <div class="sheng">
          <img src="@/assets/home/province.png" alt="" />
          <div>
            <span
              >{{ dataList.length > 0 ? dataList[0][1].total : "0"
              }}<b style="font-size: 14px">人</b></span
            >
            <p>省(部)级</p>
          </div>
        </div>
        <div class="ting">
          <img src="@/assets/home/office.png" alt="" />
          <div>
            <span
              >{{ dataList.length > 0 ? dataList[0][2].total : "0"
              }}<b style="font-size: 14px">人</b></span
            >
            <p>厅局(市)级</p>
          </div>
        </div>
        <div class="ting">
          <img src="@/assets/home/xq.png" alt="" />
          <div>
            <span
              >{{ dataList.length > 0 ? dataList[0][3].total : "0"
              }}<b style="font-size: 14px">人</b></span
            >
            <p>县(区)级</p>
          </div>
        </div>
      </div>
    </div>
    <el-row :gutter="20" style="border-radius: 8px; overflow: hidden">
      <el-col :span="12" class="echart_tu">
        <div class="tit_echart">各级别获奖人数统计</div>
        <Echart1
          ref="echart1"
          :main="'main1'"
          :seriesDate="dataList[1]"
          :type="'bar'"
          :title="''"
          :xAxisDate="['国家级', '省(部)级', '厅局(市)级', '县(区)级']"
        ></Echart1>
      </el-col>
      <el-col :span="12" class="echart_tu">
        <div class="tit_echart">国家级荣誉获奖人数各年龄段占比数据</div>
        <Echart1
          ref="echart2"
          :main="'main2'"
          :seriesDate="dataList[2]"
          :radius="['40%', '70%']"
          :type="'pie'"
          :title="'国家级荣誉获奖人数个年龄段占比数据'"
        ></Echart1>
      </el-col>
    </el-row>
    <el-row :gutter="20" style="border-radius: 8px; overflow: hidden">
      <el-col :span="12" class="echart_tu">
        <div class="tit_echart">省（部）级荣誉获奖人数各年龄段占比数据</div>
        <Echart1
          ref="echart3"
          :main="'main3'"
          :seriesDate="dataList[3]"
          :type="'pie'"
          :title="'省(部)级荣誉获奖人数个年龄段占比数据'"
        ></Echart1>
      </el-col>
      <el-col :span="12" class="echart_tu">
        <div class="tit_echart">厅局（市）级荣誉获奖人数各年龄段占比数据</div>
        <Echart1
          ref="echart4"
          :main="'main4'"
          :seriesDate="dataList[4]"
          :type="'pie'"
          :title="'厅局(市)级荣誉获奖人数个年龄段占比数据'"
        ></Echart1>
      </el-col>
    </el-row>
    <el-row :gutter="20" style="border-radius: 8px; overflow: hidden">
      <el-col :span="12" class="echart_tu">
        <div class="tit_echart">县(区)级荣誉获奖人数各年龄段占比数据</div>
        <Echart1
          ref="echart5"
          :main="'main5'"
          :seriesDate="dataList[5]"
          :type="'pie'"
          :title="'省(部)级荣誉获奖人数个年龄段占比数据'"
        ></Echart1>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Echart1 from "@/components/echart.vue";
import { statiSticsTotal, getAllRegion, regionList } from "@/api/open";
import { times } from "@/filters/index";
export default {
  components: {
    Echart1,
  },
  data() {
    return {
      selectedOptions: [],
      level: "",
      optionProps: {
        value: "id",
        level: "level",
        checkStrictly: true,
        children: "children",
      },
      area: {},
      optionsList: [],
      dataList: [],
      jcy: "",
      city: "",
      time: [],
      restaurants: [], //检察院
      shilist: [
        { name: "南京市", id: "8ad881c94d9efa0d014d9efbe7680001" },
        { name: "苏州市", id: "8ad881c94d9efa0d014d9f1edc23247a" },
        { name: "无锡市", id: "8ad881c94d9efa0d014d9effebab05d2" },
        { name: "常州市", id: "8ad881c94d9efa0d014d9f10d9341fe7" },
        { name: "镇江市", id: "8ad881c94d9efa0d014d9f0cf0aa1c99" },
        { name: "扬州市", id: "8ad881c94d9efa0d014d9f0a434f16b3" },
        { name: "泰州市", id: "8ad881c94d9efa0d014d9f7190244e74" },
        { name: "南通市", id: "8ad881c94d9efa0d014d9f2a31ea2d18" },
        { name: "盐城市", id: "8ad881c94d9efa0d014d9f4a76f243d5" },
        { name: "淮安市", id: "8ad881c94d9efa0d014d9f4255c53c86" },
        { name: "宿迁市", id: "8ad881c94d9efa0d014d9f7588c6564c" },
        { name: "徐州市", id: "8ad881c94d9efa0d014d9f0410a40b22" },
        { name: "连云港市", id: "8ad881c94d9efa0d014d9f34569b3563" },
      ], //市
      jc: [],
    };
  },
  methods: {
    // 选择检察院
    handleChange(val) {
      const obj = this.$refs["demoCascader"].getCheckedNodes();
      console.log(obj[0].data); // 打印出当前选择的value所对应的对象
      this.level=obj[0].data.level
      this.jcy = val[val.length - 1] ? val[val.length - 1] : "";
      this.area = {
        jcy1: val[0],
        jcy2: val[1] ? val[1] : "",
        jcy3: val[2] ? val[2] : "",
      };
    },
    LOOK_ECHART() {
      let parmas = {
        date1: this.time.length > 0 ? this.time[0] : "",
        date2: this.time.length > 0 ? this.time[1] + 86399 : "",
        jcy_id: this.jcy,
        jcy1: this.area.jcy1,
        jcy2: this.area.jcy2,
        jcy3: this.area.jcy3,
        city: this.city,
        region_level:this.level
      };
      statiSticsTotal(parmas).then((res) => {
        this.dataList = res.data;
      });
    },
  },
  mounted() {
    let parmas = {
      jcy1: "",
      jcy2: "",
      jcy3: "",
    };
    regionList(parmas).then((res) => {
      if (res.code == 200) {
        this.optionsList = res.data;
        console.log(this.optionsList);
        this.LOOK_ECHART();
      }
    });
  },
  activated() {
    // console.log(12127878);
  },
  watch: {
    time(val) {
      if (val == null) {
        this.time = [];
      }
    },
    city(val) {
      if (val == null) {
        this.city = "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.echarts {
  padding: 10px 20px;
  .title {
    color: rgba(102, 102, 102, 100);
    font-size: 20px;
    margin-bottom: 20px;
  }
}
.df {
  display: flex;
  align-items: center;
}
/deep/.el-button {
  font-size: 0.875rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  padding: 0.7rem 0.8rem;
  border: none;
}
/deep/.el-input__inner {
  height: 36px;
  // width: 90%;
  margin-right: 10px;
}
/deep/.el-date-editor .el-range-separator {
  padding: 0;
}
.list-look {
  display: flex;
  align-items: center;
  .quansheng {
    font-size: 14px;
    width: 17%;
    height: 118px;
    background: url("../../../assets/home/echart_bj.png") no-repeat;
    background-size: cover;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-right: 15px;
    p {
      margin-left: 21px;
      font-size: 14px;
      font-family: PingFang SC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      span {
        font-size: 38px;
      }
    }
  }
  .quansheng-right {
    width: 83%;
    height: 118px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
  }
  .guo,
  .sheng,
  .ting {
    width: 23%;
    text-align: center;
    display: flex;
    align-items: center;
    img {
      width: 40px;
      height: 40px;
      margin-right: 13px;
    }
    p {
      font-size: 14px;
      font-family: Roboto-Regular, Roboto;
      font-weight: 400;
      color: #999999;
    }
    span {
      font-size: 25px;
      font-family: Roboto-Bold, Roboto;
      font-weight: bold;
      color: #333333;
    }
  }
}
.tit_echart {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: 600;
  color: #000000;
  line-height: 21px;
  &::before {
    content: "";
    display: inline-block;
    vertical-align: 8px;
    margin: 0 10px;
    width: 4px;
    height: 20px;
    border-radius: 10px;
    background: #1d83ff;
  }
}
.echart_tu {
  background: #fff;
  // border-radius: 8px 8px 8px 8px;
  padding: 25px 0;
  margin-top: 15px;
}
/deep/.el-row {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
/deep/.el-form-item {
  margin-bottom: 0 !important;
}

.tit_search {
  display: flex;
  background: #fff;
  border-radius: 8px;
  padding: 9px;
  margin-bottom: 10px;
}
</style>
